var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-simple",attrs:{"href":"#","type":"button","id":"forgotPassword"},on:{"click":function($event){return _vm.passowrdReset()}}},[_vm._v(" "+_vm._s(_vm.$t('common.labels.forgotYourPassword'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }